import { SandboxDomainError } from '../errors';
import { SandboxState, SandboxTask, SandboxWorker } from '../types';

export interface SandboxTaskInput {
  title?: unknown;
  assigned_to?: unknown;
  deadline_at?: unknown;
}

const hasField = (
  input: SandboxTaskInput,
  field: keyof SandboxTaskInput
): boolean => Object.prototype.hasOwnProperty.call(input, field);

const taskById = (state: SandboxState, id: number): SandboxTask => {
  const task = state.tasks.find((item) => item.id === id);
  if (!task) throw new SandboxDomainError('Задача не найдена');
  return task;
};

const taskTitle = (value: unknown): string => {
  const title = String(value ?? '').trim();
  if (title.length < 3 || title.length > 60) {
    throw new SandboxDomainError(
      'Название задачи должно содержать от 3 до 60 символов'
    );
  }
  return title;
};

const worker = (state: SandboxState, value: unknown): SandboxWorker | null => {
  if (value === null || value === undefined || value === '') return null;
  const assignedTo = state.workers.find((item) => item.id === Number(value));
  if (!assignedTo) throw new SandboxDomainError('Сотрудник не найден');
  return assignedTo;
};

const deadline = (value: unknown): string | null => {
  if (value === null || value === undefined || value === '') return null;
  const date = String(value);
  if (!Number.isFinite(Date.parse(date))) {
    throw new SandboxDomainError(
      'У задачи должна быть корректная дата выполнения'
    );
  }
  return date;
};

export const createTaskAction = (
  state: SandboxState,
  input: SandboxTaskInput,
  timestamp: string
): SandboxTask => {
  const task: SandboxTask = {
    __typename: 'WorkerTask',
    origin: 'runtime',
    id: state.nextTaskId++,
    title: taskTitle(input.title),
    assigned_to: worker(state, input.assigned_to),
    deadline_at: deadline(input.deadline_at),
    finished_at: null,
    created_at: timestamp,
    updated_at: timestamp,
  };
  state.tasks.unshift(task);
  return task;
};

export const updateTaskAction = (
  state: SandboxState,
  id: number,
  input: SandboxTaskInput,
  timestamp: string
): SandboxTask => {
  const task = taskById(state, id);
  if (hasField(input, 'title')) task.title = taskTitle(input.title);
  if (hasField(input, 'assigned_to')) {
    task.assigned_to = worker(state, input.assigned_to);
  }
  if (hasField(input, 'deadline_at')) {
    task.deadline_at = deadline(input.deadline_at);
  }
  task.updated_at = timestamp;
  return task;
};

export const deleteTaskAction = (
  state: SandboxState,
  id: number
): SandboxTask => {
  const task = taskById(state, id);
  state.tasks = state.tasks.filter((item) => item.id !== id);
  return task;
};

export const setTaskCompletedAction = (
  state: SandboxState,
  id: number,
  value: boolean,
  timestamp: string
): SandboxTask => {
  const task = taskById(state, id);
  task.finished_at = value ? timestamp : null;
  task.updated_at = timestamp;
  return task;
};
